export const MARKET_IDS_TO_HIDE: string[] = []
